export const STAGES = [
  { key: "paid", label: "New / To pack" },
  { key: "packed", label: "Packed · ready to ship" },
  { key: "shipped", label: "Shipped · in transit" },
  { key: "delivered", label: "Delivered" },
  { key: "cancelled", label: "Cancelled" },
];
export const NEXT = { paid: "packed", packed: "shipped", shipped: "delivered" };

export function StageBadge({ stage }) {
  const tones = {
    paid: "bg-amber-50 text-amber-800 border-amber-200",
    packed: "bg-sky-50 text-sky-800 border-sky-200",
    shipped: "bg-indigo-50 text-indigo-800 border-indigo-200",
    delivered: "bg-emerald-50 text-emerald-800 border-emerald-200",
    cancelled: "bg-rose-50 text-rose-800 border-rose-200",
  };
  return (
    <span className={`inline-flex items-center text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-full border ${tones[stage] || "bg-stone-100 text-stone-700"}`} data-testid={`stage-${stage}`}>
      {stage}
    </span>
  );
}

export function VendorStatusBadge({ status }) {
  const labels = {
    pending_invite: { label: "Pending invite", tone: "bg-stone-100 text-stone-700 border-stone-200" },
    profile_submitted: { label: "Review pending", tone: "bg-amber-50 text-amber-800 border-amber-200" },
    approved: { label: "Live", tone: "bg-emerald-50 text-emerald-800 border-emerald-200" },
    suspended: { label: "Suspended", tone: "bg-rose-50 text-rose-800 border-rose-200" },
  };
  const info = labels[status] || { label: status || "—", tone: "bg-stone-100 text-stone-700 border-stone-200" };
  return (
    <span className={`inline-flex items-center text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-full border ${info.tone}`} data-testid={`vendor-status-${status}`}>
      {info.label}
    </span>
  );
}

export function Sparkline({ series }) {
  if (!series?.length) return null;
  const max = Math.max(1, ...series.map(p => p.amount));
  const W = 480, H = 80, pad = 4;
  const dx = (W - 2*pad) / Math.max(1, series.length - 1);
  const pts = series.map((p, i) => `${(pad + i*dx).toFixed(1)},${(H - pad - (p.amount/max)*(H-2*pad)).toFixed(1)}`).join(" ");
  const area = `${pad},${H-pad} ${pts} ${(W-pad).toFixed(1)},${H-pad}`;
  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="w-full" data-testid="farm-revenue-spark" aria-label="30-day revenue">
      <polygon points={area} fill="rgba(26,67,49,0.10)"/>
      <polyline points={pts} fill="none" stroke="var(--ff-primary)" strokeWidth="2"/>
    </svg>
  );
}
